<div class="access-title">
	<div>Bases de conocimiento</div>
	<div class="arrow__icon" [ngClass]="( isCollapsed$ | async )? '': 'expanded'" (click)="toggleCollapse( $event )" gtagEvent="colapsar" gtagCategory="base-de-conocimiento-widget">
		<span></span>
		<span></span>
	</div>
</div>

<div [@smoothCollapse]="( isCollapsed$ | async )? 'collapsed': 'expanded'">
	<ng-container *ngFor="let config of cardsConfig">
		<ng-container *ngTemplateOutlet="card; context config"></ng-container>
	</ng-container>
</div>


<ng-template #card let-title="title" let-class="class" let-key="key" let-isExternal="isExternal">

	<div *ngIf="isExternal" class="access-content" [managedLink]="key" [gtagEvent]="'ver-' + key.toLowerCase()" gtagCategory="base-de-conocimiento-widget">
		<div class="access-content__data-icon"><div [ngClass]="class"></div></div>
		<div class="access-content__data">{{title}}</div>
	</div>

	<div *ngIf="!isExternal" class="access-content" [routerLink]="'/' + key" routerLinkActive="access-content--active" [gtagEvent]="'ver-' + key.toLowerCase()" gtagCategory="base-de-conocimiento-widget">
		<div class="access-content__data-icon"><div [ngClass]="class"></div></div>
		<div class="access-content__data">{{title}}</div>
	</div>

</ng-template>
